import { render, staticRenderFns } from "./VisibilidadReducidaButaca.vue?vue&type=template&id=152464da"
import script from "./VisibilidadReducidaButaca.vue?vue&type=script&lang=js"
export * from "./VisibilidadReducidaButaca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports